import React from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";

import ScrollToTopOnMount from "./components/utilities/ScrollToTopOnMount";

import BlogState from "./Context/BlogState";
import WorksState from "./Context/WorksState";

import Navbar from "./components/Navbar";
import Dashboard from "./Dashboard";
import Footer from "./components/Footer";
import Contact from "./components/Contact";
import About from "./components/About";
import Works from "./components/Works";
import Proyect from "./components/Layout/Proyect";
import Blog from "./components/Layout/Blog";
import Login from "./components/Login";
import PostCompletoBlog from "./components/Layout/postCompletoBlog";

import AboutImg1 from "./images/logo.png";
import AboutImg2 from "./images/portada.png";

function App() {
  return (
    <BlogState>
      <WorksState>
        <Router>
          <Navbar />
          <div className="App">
            <ScrollToTopOnMount />

            <Switch>
              <Route exact path="/" component={Dashboard} />
              <Route exact path="/about">
                <About img1={AboutImg1} img2={AboutImg2} />
              </Route>
              <Route exact path="/works">
                <Works titulo={"Ultimos trabajos"} />
              </Route>
              <Route exact path="/works/:id" component={Proyect} />

              <Route exact path="/contact" component={Contact} />
              <Route exact path="/blog" component={Blog} />
              <Route exact path="/blog/:id" component={PostCompletoBlog} />
              <Route exact path="/login" component={Login} />
            </Switch>
            <Footer />
          </div>
        </Router>
      </WorksState>
    </BlogState>
  );
}

export default App;
